import { Injectable } from "@angular/core";

@Injectable()
export class FilterDataService {
  masterArray: any[] = [];
  collapsed: number = -1;
  toFilterArray: any[] = [];
  inputValues: Map<string, Set<any>> = new Map<string, Set<any>>();

  curFilter() {
    return this.masterArray[this.collapsed]?.Filters || [];
  }

  getNamesWithFilters() {
    return this.masterArray
      .filter((item) => item.Filters.length > 0)
      .map((obj) => obj.Name);
  }

  filtersActivated() {
    return this.masterArray.some((item) => item.Filters.length > 0);
  }

  removeFiltersByName(name: string) {
    const curObject = this.masterArray.find((item) => item.Name === name);
    if (curObject) curObject.Filters = [];
    if (this.collapsed !== -1 && this.masterArray[this.collapsed].Name === name)
      this.collapsed = -1;
  }

  getMinDate(colName: string) {
    if (colName.includes(".")) return this.nestedDate(colName);
    let min: Date = new Date();
    let cur: Date;
    const dayconf = new Set<number>();

    for (let item of this.toFilterArray) {
      if (!item[colName]) continue;
      cur = new Date(item[colName]);
      cur.setHours(0, 0, 0, 0);
      if (cur < min) min = cur;
      dayconf.add(cur.getTime());
    }

    this.inputValues.get(colName).add(min);
    this.inputValues.get(colName).add(this.getConfigDays(dayconf));
  }

  nestedDate(colName: string) {
    let final: any;
    let colNameParams = colName.split(".");
    let min: Date = new Date();
    let cur: Date;
    const dayconf = new Set<number>();

    for (let value of this.toFilterArray) {
      final = value[colNameParams[0]];
      for (let i = 1; i < colNameParams.length; i++) {
        final = final[colNameParams[i]];
      }
      cur = new Date(final);
      cur.setHours(0, 0, 0, 0);
      if (cur < min) min = cur;
      dayconf.add(cur.getTime());
    }

    this.inputValues.get(colName).add(min);
    this.inputValues.get(colName).add(this.getConfigDays(dayconf));
  }

  getConfigDays(dates: Set<number>): { date: Date; marked: boolean }[] {
    let dayConfigs = [];

    for (let curDate of dates) {
      dayConfigs.push({
        date: new Date(curDate),
        marked: true,
      });
    }

    return dayConfigs;
  }

  /**
   * Initializes the array with all the elements to be displayed to the user and groups them by column name.
   *
   * @param colName Column name from which values are to be obtained
   */
  initializeInput(colName: string) {
    if (colName.includes(".")) return this.nestedInput(colName);

    for (let item of this.toFilterArray) {
      if (!item[colName]) continue;
      this.inputValues.get(colName).add(item[colName]);
    }
  }

  /**
   * Initialization for the case of nested fields that cannot be accessed directly.
   */
  nestedInput(colName: string) {
    let final: any;
    let colNameParams = colName.split(".");

    for (let value of this.toFilterArray) {
      final = value[colNameParams[0]];
      for (var i = 1; i < colNameParams.length; i++) {
        final = final[colNameParams[i]];
      }
      this.inputValues.get(colName).add(final);
    }
  }

  /**
   * Returns all values associated with a given column.
   *
   * @param colName Column name from where want to get the elements.
   */
  getOptions(colName: string): string[] {
    let aux: string[] = [];
    for (let item of this.inputValues.get(colName)) {
      if (this.curFilter().some((value) => value === item)) continue;
      aux.push(item);
    }
    return aux;
  }

  clearFilters() {
    this.collapsed = -1;
    for (let colFilter of this.masterArray) {
      colFilter.Filters = [];
    }
  }
}
